import {IViewTypeWizardState} from "../../../types/ui/wizard/view-type";
import {ViewTypes} from "../../../../peregrine/processor";

export const initialViewTypeState: IViewTypeWizardState = {
  oldViewType: ViewTypes.Rendered
};
